import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IoMenu } from "react-icons/io5";
import { useSelector, useDispatch } from "react-redux";
import ChatHelp from "./chatHelp";
import chatData from "../../mockups/Chat/ChatData";
import ChatPrompt from "./ChatPrompt";
import { getUserTranscriptFromAPIAsync, postUserNeed } from "../../redux/Thunks/chatBotThunk";
import {
  selectbackground,
} from "../../redux/Slices/toggleBackgroundSlice";
import Alert from "../common/Alert";
import { userInfo } from "../../redux/Selectors/selectors";
import { addOne, toggleChatSideBar } from "../../redux/Slices/sharedUseEffectSlice";
import { clearStreamedData, getStreamedData } from "../../redux/Slices/chatBotSlice";


const ChatBoxEachPromptMain = ({sidebarOpen}) => {

  let userID;
  const user = useSelector(state => userInfo(state))

  if (user) {
    userID = user.id;
  }

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentMode = useSelector((state) => selectbackground(state));

  const [showError, setShowError] = useState(false);
  const [userPrompt, setUserPrompt] = useState({ prompt: "" });
  const [errorMsg, setErrorMsg] = useState("Oops! Something went wrong.")
  // eslint-disable-next-line
  const [connectionStatus,setConnectionStatus] = useState("")

  const toggleNavbar = () => {
      dispatch(toggleChatSideBar())
  }


  const handleChange = (e) =>
    setUserPrompt((prevValue) => {
      return {
        ...prevValue,
        prompt: e.target.value,
      };
    })

    // ASK BOT REUSABLE FUNCTION
async function talk_to_bot(question){
  if(userID){
    try {
      dispatch(clearStreamedData())
      setUserPrompt({ prompt: "" });
      dispatch(
        postUserNeed({
          prompt: question,
          transcript_id : null,
        })
      )
    } catch (rejectedValueOrSerializedError) {
        setShowError(true) 
        setErrorMsg(rejectedValueOrSerializedError || "Ooops, Server error!")
    }
}else{
  setErrorMsg("Ooops, you are not logged in.")
  setShowError(true)
}
}


  // Submitting the user_prompt
  const handleClick = async (e) => {
    e.preventDefault();
    talk_to_bot(userPrompt.prompt)
  };

// Auto Prompting
const prompt_1_Clicked = (e) => {
  let prompt = e.target.innerText
  talk_to_bot(prompt)
}

// eslint-disable-next-line
const prompt_2_Clicked = (e) => {
  let prompt = e.target.innerText
  talk_to_bot(prompt)
}


  useEffect(() => {
      const unFilteredURL = `wss://${process.env.REACT_APP_SERVER_URL}/ws/create-messages/${userID}/`;
      let wsUrl = unFilteredURL.replace("https://", "")

      if(process.env.REACT_APP_ENV === "development"){
        wsUrl = `ws://localhost:8000/ws/create-messages/${userID}/`;
      }

      const ws = new WebSocket(wsUrl);

    ws.onopen = () => {
      console.log('WebSocket Connected');
      setConnectionStatus('connected');
    };

    ws.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);

        if(data.type === "start"){
            const newPageURL = `/chat/${data.transcript_id}`; 
            navigate(newPageURL, {state: {prompt : data?.user_prompt}}); 
          }else if (data.type === 'end') {
            dispatch(getUserTranscriptFromAPIAsync({user_id : userID}))
            return;
          }else if(data.type === "chat_generated"){
            dispatch(getStreamedData(data))
          }
      } catch (err) {
        console.error('Error parsing message:', err);
      }
    };

    ws.onclose = (e) => {
      console.log('Chat WebSocket Closed', e);
      setConnectionStatus('disconnected');
    };

    ws.onerror = (e) => {
      console.error('Chat WebSocket Error', e);
      setConnectionStatus('error');
    };

    // Cleanup function
    return () => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.close();
      }
    };

  // eslint-disable-next-line
  }, [userID]);

  useEffect(() => {

    // RESET STATES IN THE sharedUseEffectSlice file
    dispatch(
      addOne({
        isFive : 0
    })
    )

    if (showError) {
      // Set a timeout to hide the error alert after 5 seconds
      const timeout = setTimeout(() => {
        setShowError(false);
      }, 3000);

      // Clear the timeout if the component unmounts or if showError changes
      return () => clearTimeout(timeout);
    }
  // eslint-disable-next-line
  }, [showError]);



  return (
    <div
      className={`w-full lg:w-4/5 relative pt-12 sm:pt-2.5 pb-5 h-screen ${sidebarOpen && "blur-sm lg:blur-none"}
          ${!currentMode ? `bg-white text-black` : `bg-nightModeDark text-white`} `}
    >

      <button
        className="lg:hidden m-3 text-3xl absolute top-0 left-1 z-10"
        onClick={toggleNavbar}>
        <IoMenu  className={`${currentMode ? "text-chatTipBackground" : "text-nightModeDark"}`}/>
      </button>

      {/* Chat data to display on chat page */}
    <div className="px-5 pb-[70px] flex flex-col justify-center h-screen overflow-y-scroll no-scrollbar">
      {chatData && chatData.map((chat, index) => {
        return <ChatHelp
               key={index}
               chathelp={chat}
                mode={!currentMode}
                prompt1Clicked={prompt_1_Clicked}
                // prompt2Clicked={prompt_2_Clicked} 

                />
      })}
      </div>


      {showError && <Alert
        isVisible={showError}
        message={errorMsg}
        type="error"
      />}

      <ChatPrompt
        currentMode={currentMode}
        bgOnDark="bg-nightModeDark"
        placeholder='Hi, Let’s talk policies today!'
        position="absolute"
        submitPrompt={handleClick}
        value={userPrompt.prompt}
        handleChange={handleChange} />

    </div>
  );
}

export default ChatBoxEachPromptMain;
